<template>
  <div class="d-flex flex-column parent-container">
    <div class="nav-bar-layout-container">
      <TaazeNavbar />
    </div>
    <div class="flex-grow-1 layout-container chat-container">
      <div class="d-flex flex-column">
        <div class="chat-header chat-content align-self-center">Talk to the books <div class="chat-sub-header">{{ VERSION }} 版
          </div>
        </div>
        <div v-for="(chat, index) in chatHistory" :key="index" :chat-index="index">
          <ChatMessage :chat="chat" :is-prompting-enabled="false" :is-share-enabled="false" />
        </div>

      </div>
    </div>
    <div v-if="product !== null" class="product-card-chat-container layout-container">
      <ProductCard :product="product" />
    </div>
  </div>

</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { SharedResponseService } from '@/services/SharedResponseService';
import { v4 as uuidv4 } from 'uuid';

import ProductRepository from '@/repositories/ProductRepository';
import ProductCard from '@/components/ProductCard.vue';
import TaazeNavbar from '@/components/layout/TaazeNavbar.vue';
import ChatMessage from '@/components/ChatMessage.vue'
import Chat from '@/interfaces/Chat';
import Product from '@/models/Product';

const VERSION = process.env.VUE_APP_VERSION;

const route = useRoute();
const shareId = route.params.shareId;
const sharedResponseService = new SharedResponseService(process.env.VUE_APP_TALK_TO_THE_BOOK_API_URL!);
const productRepository = new ProductRepository(process.env.VUE_APP_TAAZE_API_URL!);

const chatHistory = ref<Chat[]>([]);

let product: Product | null = null;

onMounted(async () => {
  await setup();
});

async function setup() {
  const sharedResponse = await sharedResponseService.getSharedResponseById(String(shareId));

  product = await productRepository.getProductById(sharedResponse.productId);

  chatHistory.value.push(
    {
      id: uuidv4(),
      type: 'user',
      content: sharedResponse.question,
      suggestions: [],
      isLoading: false,
      isGenerating: false
    }
  );

  chatHistory.value.push(
    {
      id: uuidv4(),
      type: 'bot',
      content: sharedResponse.response,
      suggestions: [],
      isLoading: false,
      isGenerating: false
    }
  );
}
</script>

<style scoped>
.parent-container {
  padding: 0;
  margin: 0;
  height: 100dvh;
  background-color: #F5EEE6;
}

.layout-container {
  padding-left: 16px;
  padding-right: 16px;
}

.chat-container {
  padding-top: 16px;
  padding-bottom: 16px;
  overflow: auto;
}

.chat-container::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.chat-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.chat-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.chat-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.chat-header {
  font-family: 'Noto Sans TC', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #68444A;
}

.chat-content {
  margin-bottom: 16px;
  gap: 16px;
}

.chat-sub-header {
  display: inline;
  font-family: 'Noto Sans TC', sans-serif;
  font-size: 14px;
  font-weight: 400;
}

.product-card-chat-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: white;
  padding-top: 16px;
  padding-bottom: 16px;
}

@media (min-width: 768px) {
  .layout-container {
    padding-left: 78px;
    padding-right: 78px;
  }
}

@media (min-width: 1200px) {
  .layout-container {
    padding-left: 100px;
    padding-right: 100px;
  }

  .nav-bar-layout-container {
    padding-left: 100px;
    padding-right: 100px;
  }
}

.slide-fade-enter-active {
  transition: all 0.6s ease-out;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
</style>